import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData_Bus from "./NoData_Bus";
import ChartLoader_Bus from "./ChartLoader_Bus";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import BucketTable_bus_neteng from "./BucketTable_bus_neteng";
import BucketTable_bus_netkwh from "./BucketTable_bus_netkwh";
import WaterMark from "../../../componets/Dashboard/DashboardMain/WaterMark";

export default function NetEnergyConsumptionkwh({ apiend, gloablfilter, title, type }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [fieldname, SetFieldName] = useState("median_whPerKM");

  let modal_title = title;

  const appyData = (data) => {
    if (type === "netenergy")
      SetFieldName("median_whPerKM")
    else
      SetFieldName("median_NetkWh")
    const res_result = data;
    let res_result_final = []
    let responce = {
      "<1.3": 0,
      "1.4": 0,
      "1.5": 0,
      "1.6": 0,
      "1.7": 0,
      "1.8": 0,
      "1.9": 0,
      "2": 0,
      ">2": 0,
    };

    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map(d => {
        let value = parseFloat(d.median_whPerKM.values["50.0"]);
        if (isNaN(value))
          value = 0
        if ((d.median_whPerKM.values["50.0"] === null))
          d.median_whPerKM.values["50.0"] = 0.00000
        if (value < 1.3) {
          responce["<1.3"] = responce["<1.3"] + 1;
        } else if (value >= 1.3 && value < 1.4) {
          responce["1.4"] = responce["1.4"] + 1;
        } else if (value >= 1.4 && value < 1.5) {
          responce["1.5"] = responce["1.5"] + 1;
        } else if (value >= 1.5 && value < 1.6) {
          responce["1.6"] = responce["1.6"] + 1;
        } else if (value >= 1.6 && value < 1.7) {
          responce["1.7"] = responce["1.7"] + 1;
        }
        else if (value >= 1.7 && value < 1.8) {
          responce["1.8"] = responce["1.8"] + 1;
        }
        else if (value >= 1.8 && value < 1.9) {
          responce["1.9"] = responce["1.9"] + 1;
        }
        else if (value >= 1.9 && value < 2) {
          responce["2"] = responce["2"] + 1;
        }
        else if (value >= 2) {
          responce[">2"] = responce[">2"] + 1;
        }
      })
      res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);
      loop_keys = ["<1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2", ">2"]
      loop_keys.map(x => {
        // res_result_final.push([x, responce[x], "#83A4CF"]);
        res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }
  const appyDatakwh = (data) => {
    if (type === "netenergy")
      SetFieldName("median_whPerKM")
    else
      SetFieldName("median_NetkWh")
    const res_result = data;
    let res_result_final = []
    let responcekwh = {
      "<100": 0,
      "150": 0,
      "200": 0,
      "250": 0,
      "300": 0,
      ">300": 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;

      temp_result.map(d => {
        let value = parseFloat(d.median_NetkWh.values["50.0"]);
        if (isNaN(value))
          value = 0
        if ((d.median_NetkWh.values["50.0"] === null))
          d.median_NetkWh.values["50.0"] = 0.00000
        if (value < 100) {
          responcekwh["<100"] = responcekwh["<100"] + 1;
        } else if (value >= 100 && value < 150) {
          responcekwh["150"] = responcekwh["150"] + 1;
        } else if (value >= 150 && value < 200) {
          responcekwh["200"] = responcekwh["200"] + 1;
        } else if (value >= 200 && value < 250) {
          responcekwh["250"] = responcekwh["250"] + 1;
        } else if (value >= 250 && value < 300) {
          responcekwh["300"] = responcekwh["300"] + 1;
        }
        else if (value >= 300) {
          responcekwh[">300"] = responcekwh[">300"] + 1;
        }
      })
      res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responcekwh);
      loop_keys = ["<100", "150", "200", "250", "300", ">300"]
      loop_keys.map(x => {
        // res_result_final.push([x, responcekwh[x], "#83A4CF"]);
        res_result_final.push([x, responcekwh[x], "stroke-width: 1;stroke-color: black;"]);
      })
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }
  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'kWh',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "buscharts/" + apiend, body: { filterdata: gloablfilter } }, appyDatakwh)
  }, [gloablfilter, apiend])

  return (
    <>
      <div className="chartHGT">
        <WaterMark />
        {(isLoading) ? <ChartLoader_Bus /> : ((chartdata.length == 0) ? <NoData_Bus /> : <Chart chartType="ColumnChart" width="100%" height="210px" data={chartdata} options={options} chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              if (selection.length === 1) {
                const [selectedItem] = selection;
                const { row } = selectedItem;

                const barvalue = chartWrapper.getDataTable().Wf[row].c[0].v;
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                if (count != 0) {
                  let filtered_temp = [];

                  if ((fieldname === "median_NetkWh")) {
                    filtered_temp = apiresponce.filter(x => {

                      if (x.median_NetkWh.values["50.0"] < barvalue && x.median_NetkWh.values["50.0"] >= barvalue - 50) {

                        return x;
                      }
                      else if (x.median_NetkWh.values["50.0"] >= 300 && barvalue === ">=300") {
                        return x
                      }
                      else if (x.median_NetkWh.values["50.0"] < 100 && barvalue === "<100") {
                        return x
                      }
                    })
                  }

                  function compareObjects(object1, object2, key) {
                    let obj1 = []
                    let obj2 = []
                    if (fieldname === "median_whPerKM") {
                      obj1 = object1.median_whPerKM.values["50.0"]
                      obj2 = object2.median_whPerKM.values["50.0"]
                    }
                    else if (fieldname === "median_NetkWh") {
                      obj1 = object1.median_NetkWh.values["50.0"]
                      obj2 = object2.median_NetkWh.values["50.0"]
                    }
                    if (obj1 > obj2) {
                      return -1
                    }
                    if (obj1 < obj2) {
                      return 1
                    }
                    return 0
                  }

                  filtered_temp.sort((value1, value2) => {
                    return compareObjects(value1, value2, 'vehicalId')
                  })
                  SetfilteredData(prestate => filtered_temp);
                  window.$('#exampleModal__' + apiend).modal('show');
                }
              }
            }
          }
        ]}
        />)}

        <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">{"kWh"}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
              <div className="modal-body">
                {/* <table className="table table-striped">
                  <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                    <tr>
                      <th scope="col">Vin Number</th>
                      <th scope="col">value</th>
                    </tr></thead>
                  <tbody> */}
                <BucketTable_bus_netkwh data={filteredData} />
                {/* </tbody></table> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}
